module.exports = "https://www.gc-pro.gnp.com.mx/222ca70b5024941b86369fa7e98ea59a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/twitter-2.png
// module id = 8167
// module chunks = 0